import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Heading } from '@/common/components/heading';

export const Route = createFileRoute('/applications/$application-id/end')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div className="p-8">
      <Heading>Submit Application</Heading>

      <ButtonGroup>
        <Button to="/apply">Submit Application</Button>
      </ButtonGroup>
    </div>
  );
}
